import axios from "axios";
import { getConfigHeader, refrech, URL_STATISTIQUE } from "./config";

const countSalarie = async () => {
  return refrech()
    .then(() => axios.get(URL_STATISTIQUE + "count=salarie", getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const allStat = async () => {
  return refrech()
    .then(() => axios.get(URL_STATISTIQUE, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const allStatClient = async (id) => {
  return refrech()
    .then(() => axios.get(URL_STATISTIQUE + "?client=" + id, getConfigHeader()))
    .catch((error) => Promise.reject(error));
};

const allStatSalarie = async (id) => {
  return refrech()
    .then(() =>
      axios.get(URL_STATISTIQUE + "?salarie=" + id, getConfigHeader())
    )
    .catch((error) => Promise.reject(error));
};

export { allStat, allStatClient, countSalarie, allStatSalarie };
